import { CheckYesIcon, ExclaimCircleIcon, Tooltip, XNoIcon } from "@minervaproject/fds";
import clsx from "clsx";
import { ReactNode } from "react";

type TDPropTypes = {
  conditionForDanger?: boolean;
  conditionForInfo?: boolean;
  conditionForWarning?: boolean;
  noWrap?: boolean;
  scrollX?: boolean;
  onClick?: () => void;
  title?: string;
  children: ReactNode;
  className?: string;
  dataTestId?: string;
};

const TD = ({
  conditionForDanger,
  conditionForInfo,
  conditionForWarning,
  noWrap,
  scrollX,
  onClick,
  title,
  children,
  className,
  dataTestId,
}: TDPropTypes) => {
  const cName = clsx(
    {
      "scroll-x": scrollX,
      "tooltip-container": title,
    },
    className,
  );
  return (
    <td
      onClick={onClick}
      className={cName}
      style={{
        whiteSpace: noWrap ? "nowrap" : "normal",
        padding: "0.3rem",
        backgroundColor: conditionForDanger
          ? "#f5c6cb"
          : conditionForWarning
            ? "#ffeeba"
            : conditionForInfo
              ? "#bee5eb"
              : undefined,
      }}
      title={title}
      data-testid={dataTestId}
    >
      {children}
      {/* {title ? <span>{title}</span> : null} */}
    </td>
  );
};

type THPropTypes = {
  preWrap?: boolean;
  title?: string;
  style?: Record<string, string>;
  children: ReactNode;
};

const TH = ({ children, preWrap, title, style }: THPropTypes) => {
  return (
    <th
      className={`align-top${title ? " tooltip-container" : ""}`}
      style={{
        position: "sticky",
        backgroundColor: "steelblue",
        color: "white",
        whiteSpace: preWrap ? "pre-wrap" : "nowrap",
        padding: "0.3rem",
        ...style,
      }}
      title={title}
    >
      {children}
      {/* {title ? <span>{title}</span> : null} */}
    </th>
  );
};

const TDStatusIconWithTooltip = ({
  conditionForDanger = false,
  conditionForWarning = false,
  children,
  dataTestId,
}: {
  conditionForDanger?: boolean;
  conditionForWarning?: boolean;
  children: ReactNode;
  dataTestId?: string;
}) => {
  if (!children) return <TD dataTestId={dataTestId}> </TD>;
  return (
    <TD
      conditionForDanger={conditionForDanger}
      conditionForWarning={conditionForWarning}
      className="center"
      dataTestId={dataTestId}
    >
      <Tooltip
        iconComponent={
          conditionForDanger ? (
            <XNoIcon />
          ) : conditionForWarning ? (
            <ExclaimCircleIcon color="orange" />
          ) : (
            <CheckYesIcon />
          )
        }
      >
        {children}
      </Tooltip>
    </TD>
  );
};

export { TD, TDStatusIconWithTooltip, TH };
